import { AbgSxProps } from '@abg/typings';

export const getRootContainerStyle = (
  onSelectLocation?: boolean,
): AbgSxProps => ({
  marginTop: '8px',
  paddingBottom: onSelectLocation ? '80px' : '0px',
});

export const sectionContainerStyle: AbgSxProps = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  gap: 5,
};

export const labelStyle: AbgSxProps = {
  flexShrink: 0,
  minWidth: '64px',
};

export const contentBoxStyle: AbgSxProps = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
};

export const dividerContainerStyle: AbgSxProps = {
  my: 3,
};

export const hoursGridStyle: AbgSxProps = {
  display: 'grid',
  gridTemplateColumns: '1fr 2fr',
  gap: 1,
};

export const fixedBottomButtonContainerStyle: AbgSxProps = {
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  p: 2,
  boxShadow: '0px -2px 10px 0px rgba(0, 0, 0, 0.06)',
  background: '#FFFFFF',
  zIndex: 2,
};

export const selectButtonStyle: AbgSxProps = {
  py: 1.5,
  textTransform: 'none',
};
